import React from 'react'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'

import styles from './Footnote.module.less'

export default ({ location, className }) => {
  // TODO: Use actual version when we figure out where should it come from
  const appVersion = process.env.REACT_APP_VERSION

  const classNames = cx({
    [className]: !!className,
    [styles.poweredBySidebar]: location === 'sidebar',
    // TODO: [Desktop] Remove this temporary global class when App.less is refactored
    'powered-by': true,
  })

  return (
    <div className={classNames}>
      <FormattedMessage
        id="app.poweredBy"
        defaultMessage="Powered by Pathway"
      />
      {appVersion && (<span> | </span>)}
      {appVersion && (<span>{appVersion}</span>)}
    </div>
  )
}
